
<script>
import { ItemService } from "@/services/nextshop/item.service";
import { SettingService } from "@/services/nextshop/setting.service";
import Swal from "sweetalert2"

export default {
  data() {
    return {
      dataPermission: JSON.parse(localStorage.getItem("dataPermission")),
      textSearch: "",
      inforMerchant: JSON.parse(localStorage.getItem("auth.currentMerchant")),
      fields: [],
      unitName: "",
      dataUnit: [],
      fieldsUnit: [
        {
          key: "selected",
          label: "",
          thStyle: { width: "5%" },
        },
        {
          key: "unitName",
          label: "Đơn vị tính",
          thStyle: { width: "80%" },
        },
        {
          key: "optionUnit",
          label: "",
          thStyle: { width: "12%" },
        },
      ],
      unitNameUpdate: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 1,
      optionsPerPage: [
        { value: 5, text: "5" },
        { value: 10, text: "10" },
        { value: 20, text: "20" },
        { value: 50, text: "50" },
        { value: 100, text: "100" },
      ],
      selected: [],
      listId: [],
      loading: false,
      filterOn: [],
      isShow: false,
      imgSearchEmpty: require('@/assets/images/bg-chill-guy.svg'),
      imgListEmpty: require('@/assets/images/bg-working-guy.svg')
    }
  },
  created() {
    this.getListUnit();
    this.getDataMerchant();
  },
  computed: {
    selectAll: {
      get: function () {
        return this.dataUnit
          ? this.selected.length === this.dataUnit.length
          : false;
      },
      set: function (value) {
        var selected = [];
        if (value) {
          this.dataUnit.forEach(function (item) {
            selected.push(item);
          });
        }
        this.selected = selected;
      },
    },

    rows() {
      return this.dataUnit.length;
    }
  },
  methods: {
    async getDataMerchant() {
      try {

        const response = await SettingService.getDataMerchant()
        if (response.success) {
          this.mcBusinessCode = response.data.merchant.businessFieldCode
        }
      } catch (error) {
        console.log();
      }
    },

    remove() {
      this.textSearch = "";
    },

    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    async getListUnit() {
      try {
        this.loading = true;
        
        const params = {
          coMerchantId: this.inforMerchant.id,
          limit: 1000000,
          page: 1,
          unitName: this.textSearch,
        };
        const response = await ItemService.getListUnit(params);       
        if (response.success) {
          this.dataUnit = response.data;
        }
        this.loading = false;
        this.isShow = true
      } catch (error) {
        console.log(error);
      }
    },

    async createUnit() {
      try {
        this.loading = true;
        this.$refs.observerUnit.validate().then(async (valid) => {
          if (!valid) {
            const el = document.querySelector(".is-invalid");
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            el.focus();
            return;
          } else {
            const params = {
              coMerchantId: this.inforMerchant.id,
              unitName: this.unitName.trim(),
            };
            const response = await ItemService.createUnit(params);

            if (response.success) {
              this.$bvModal.hide("addUnit");
              Swal.fire({
                title: "Thành công",
                text: `Thêm mới đơn vị tính thành công`,
                icon: "success",
                confirmButtonText: "Xác nhận",
              }).then(() => {
                this.getListUnit();
              });
            } else {
              Swal.fire({
                title: "Thất bại",
                text: `Đơn vị tính đã tồn tại`,
                icon: "warning",
                cancelButtonText: "Hủy",
              })
            }
          }
          this.loading = false;
        });
      } catch (error) {
        console.log(error);
      }
    },

    deleteUnit(value) {
      this.$bvModal.show("deleteUnit");
      let listId = [];
      if (typeof value != "string") {
        this.selected.map((e) => {
          listId.push(e.id);
        });
      } else {
        listId.push(value);
      }
      this.listId = listId;
      this.selected = []
    },

    async deleteSelectedUnit() {
      try {
        this.loading = true;
        const params = {
          coMerchantId: JSON.parse(localStorage.getItem("auth.currentMerchant"))
            .id,
          listId: this.listId,
        };
        const response = await ItemService.deleteUnit(params);
        if (response.success) {
          this.loading = false;
          this.$bvModal.hide("deleteUnit");
          Swal.fire({
            title: "Thành công",
            text: `Xóa đơn vị tính thành công`,
            icon: "success",
            confirmButtonText: "Xác nhận",
          }).then(() => {
            this.getListUnit();
          });
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    async updateUnit() {
      try {
        this.loading = true;
        this.$refs.observerUpdateUnit.validate().then(async (valid) => {
          if (!valid) {
            const el = document.querySelector(".is-invalid");
            el.scrollIntoView({
              behavior: "smooth",
              block: "center",
            });
            el.focus();
            return;
          } else {
            const params = {
              coMerchantId: this.inforMerchant.id,
              id: this.dataUpdate.id,
              unitName: this.unitNameUpdate.trim(),
            };
            const response = await ItemService.updateUnit(params);
            if (response.success) {
              this.loading = false;
              this.$bvModal.hide("updateUnit");
              Swal.fire({
                title: "Thành công",
                text: `Cập nhật đơn vị tính thành công`,
                icon: "success",
                confirmButtonText: "Xác nhận",
              }).then(() => {
                this.getListUnit();
              });
            } else {
              Swal.fire({
                title: "Thất bại",
                text: `Đơn vị tính đã tồn tại`,
                icon: "warning",
                cancelButtonText: "Hủy",
              })
            }
          }
          this.loading = false
        })
      } catch (error) {
        console.log(error);
      }
    },

    updateSelectedUnit(value) {
      this.$bvModal.show("updateUnit");
      this.unitNameUpdate = value.unitName;
      this.dataUpdate = value;
    },
  }
}
</script>

<template>
  <TheLayout>
    <div v-if="dataPermission && dataPermission.includes('NSH_ITEM_PROD_CREATE')">
      <div class="page-title title">
        <span>QUẢN LÝ ĐƠN VỊ TÍNH</span>
      </div>

      <div class="main-content-layout mt-3" v-show="isShow">
        <div class="d-fex justify-content=between mb-3">
          <b-input-group class="wrapperInput d-flex justify-content-between">
            <el-input
              v-model="textSearch"
              @keyup.native.enter="getListUnit"
              placeholder="Tìm kiếm"
              prefix-icon="el-icon-search"
              style="width: 280px"
              clearable
            >
            </el-input>
            <el-button class="n-btn" type="primary" v-if="dataPermission && dataPermission.includes('NSH_ITEM_CATEG_CREATE')"
              @click="$bvModal.show('addUnit');unitName = '';">
              <div class="n-icon">
                  <i class="mdi mdi-plus"></i>
                  Thêm mới
              </div>
            </el-button>
            <!-- <el-button style="padding:7px 16px 7px 12px; height: 44px" type="primary"
              @click="$bvModal.show('addUnit');unitName = '';"><i class="fa-solid fa-plus"></i> Thêm mới
            </el-button> -->
          </b-input-group>
        </div>
        <div class="row mb-3" v-if="selected.length > 1">
          <div class="col-md-12">
            <span class="mt-2 d-inline mr-2"
              >Đã chọn {{ selected.length }} danh mục</span
            >
            <el-button @click="deleteUnit(selected)" class="n-btn" type="danger" plain>Xóa</el-button>

          </div>
        </div>

        <div class="table-responsive mb-0">
          <b-table
            class="n-table"
            head-variant="light"
            tbody-tr-class="row-table-class"
            hover
            :items="dataUnit"
            :fields="fieldsUnit"
            :filter="textSearch"
            :filter-included-fields="filterOn"
            :current-page="currentPage"
            :per-page="perPage"
            @filtered="onFiltered"
          >
            <template #table-caption>
              <div class="text-center mx-auto"
                v-if="textSearch == '' && totalRows == 0 ">
                <span class="d-block mt-5"><img :src="imgListEmpty"></span>
                <p>Danh sách của bạn chưa có đơn vị tính</p>
              </div>

              <div class="text-center mx-auto" 
                v-if="textSearch != '' && totalRows == 0 ">
                <span><img :src="imgSearchEmpty"></span>
                <p>Không tìm thấy đơn vị tính phù hợp</p>
              </div>
            </template>

            <template v-slot:head(selected)="data">
              <b-form-checkbox v-model="selectAll" :value="data.item" />
            </template>

            <template #cell(selected)="data">
              <b-form-checkbox v-model="selected" :value="data.item" />
            </template>

            <template #cell(unitName)="data">
              {{ data.item.unitName }}
            </template>

            <template #cell(optionUnit)="data">
              <div class="d-flex justify-content-between">
                <span
                  class="text-primary mr-2"
                  @click="updateSelectedUnit(data.item)"
                  >Chỉnh sửa</span
                >
                <span class="text-danger" @click="deleteUnit(data.item.id)"
                  >Xóa</span
                >
              </div>
            </template>
          </b-table>
        </div>

        <div class="clearfix">
          <div class="row d-flex justify-content-end mr-2 my-3">
            <div class="mr-3 d-flex">
              <div class="mr-2 mt-2">Hiển thị</div>

              <b-form-select
                v-model="perPage"
                :options="optionsPerPage"
                style="width: 72px; height: 32px"
              />
            </div>

            <div class="mr-3">
              <div class="mt-2">
                kết quả từ
                {{
                  currentPage * perPage - perPage + 1 > rows
                    ? rows
                    : currentPage * perPage - perPage + 1
                }}
                -
                {{
                  currentPage * perPage > rows
                    ? rows
                    : currentPage * perPage
                }}
                trên tổng
                {{ rows }} danh mục
              </div>
            </div>

            <b-pagination
              hide-goto-end-buttons
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              align="right"
            >
            </b-pagination>
          </div>
        </div>
      </div>

      <!-- =========================== MODALS =============================== -->

      <!-- modal Add unit -->
      <validation-observer ref="observerUnit" v-slot="{ invalid }">
        <b-modal modal-class="n-b-modal" id="addUnit" no-close-on-backdrop>
          <!-- header -->
          <template #modal-header>
            <b class="n-b-title">Thêm đơn vị tính</b>
            <button type="button" aria-label="Close" @click="$bvModal.hide('addUnit')">
              <i class="el-icon-close"></i>
            </button>
          </template>
          <!-- body -->
          <template #default>
            <label for="input-content"
              >Đơn vị tính <span style="color: red">*</span></label
            >

            <validation-provider
              name="Đơn vị tính"
              rules="required|lBetween:1,255|CHECK_HTML"
              v-slot="{ errors, valid }"
            >
              <b-form-input
                v-model="unitName"
                id="input-content"
                :state="errors[0] ? false : valid ? true : null"
                @keydown.enter.prevent
                placeholder="Nhập đơn vị tính"
              />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>

          <!-- footer -->
          <template #modal-footer>
            <div class="d-flex justify-content-end">
              <el-button class="n-btn" @click="$bvModal.hide('addUnit')">
                Thoát
              </el-button>
              <el-button :disabled="invalid" class="n-btn" type="primary" @click="createUnit">
                Hoàn tất
              </el-button>
            </div>
          </template>
        </b-modal>

        <!-- <b-modal id="addUnit" no-close-on-backdrop>
          <template #modal-header>
            <h5 class="mb-0"><b>Thêm đơn vị tính</b></h5>
            <button
              type="button"
              aria-label="Close"
              class="close"
              @click="$bvModal.hide('addUnit')"
            >
              ×
            </button>
          </template>
          <template #default>
            <label for="input-content"
              >Đơn vị tính <span style="color: red">*</span></label
            >

            <validation-provider
              name="Đơn vị tính"
              rules="required|lBetween:1,255|CHECK_HTML"
              v-slot="{ errors, valid }"
            >
              <b-form-input
                v-model="unitName"
                id="input-content"
                :state="errors[0] ? false : valid ? true : null"
                @keydown.enter.prevent
                placeholder="Nhập đơn vị tính"
              />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>
          <template #modal-footer>
            <div class="d-flex justify-content-between w-100 m-0">
              <b-button
                variant="outline-primary"
                size="md"
                class="m-0"
                @click="$bvModal.hide('addUnit')"
                >Thoát</b-button
              >
              <b-button
                :variant="invalid ? 'secondary' : 'primary'"
                size="md"
                class="m-0"
                :disabled="invalid"
                @click="createUnit"
                >Hoàn tất</b-button
              >
            </div>
          </template>
        </b-modal> -->
      </validation-observer>
      <!--  end of modal add unit -->

      <!-- modal update unit -->
      <validation-observer ref="observerUpdateUnit" v-slot="{invalid}">
        <b-modal modal-class="n-b-modal" id="updateUnit" no-close-on-backdrop>
          <!-- header -->
          <template #modal-header>
            <b class="n-b-title">Chỉnh sửa đơn vị tính</b>
            <button type="button" aria-label="Close" @click="$bvModal.hide('updateUnit')">
              <i class="el-icon-close"></i>
            </button>
          </template>
          <!-- body -->
          <template #default>
            <label for="input-content"
              >Đơn vị tính <span style="color: red">*</span></label
            >
            <validation-provider 
              name="Đơn vị tính"
              rules="required|lBetween:1,255|CHECK_HTML"
              v-slot="{ errors, valid }"
            >
              <b-form-input
                id="input-content"
                :state="errors[0] ? false : valid ? true : null"
                @keydown.enter.prevent
                placeholder="Nhập đơn vị tính"
                v-model="unitNameUpdate"
              />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>

          <!-- footer -->
          <template #modal-footer>
            <div class="d-flex justify-content-end">
              <el-button class="n-btn" @click="$bvModal.hide('updateUnit')">
              Thoát
              </el-button>
              <el-button :disabled="invalid" class="n-btn" type="primary" @click="updateUnit">
                Hoàn tất
              </el-button>
            </div>
          </template>
        </b-modal>
<!-- 
        <b-modal id="updateUnit" no-close-on-backdrop>
          <template #modal-header>
            <h5 class="mb-0"><b>Chỉnh sửa đơn vị tính</b></h5>
            <button
              type="button"
              aria-label="Close"
              class="close"
              @click="$bvModal.hide('updateUnit')"
            >
              ×
            </button>
          </template>
          <template #default>
            <label for="input-content"
              >Đơn vị tính <span style="color: red">*</span></label
            >
            <validation-provider 
              name="Đơn vị tính"
              rules="required|lBetween:1,255|CHECK_HTML"
              v-slot="{ errors, valid }"
            >
              <b-form-input
                id="input-content"
                :state="errors[0] ? false : valid ? true : null"
                @keydown.enter.prevent
                placeholder="Nhập đơn vị tính"
                v-model="unitNameUpdate"
              />
              <b-form-invalid-feedback>
                {{ errors[0] }}
              </b-form-invalid-feedback>
            </validation-provider>
          </template>
          <template #modal-footer>
            <div class="d-flex justify-content-between w-100 m-0">
              <b-button
                variant="outline-primary"
                size="md"
                class="m-0"
                @click="$bvModal.hide('updateUnit')"
                >Thoát</b-button
              >
              <b-button 
                size="md" 
                class="m-0" 
                @click="updateUnit"
                :variant="invalid ? 'secondary' : 'primary'"
                :disabled="invalid"
                >Hoàn tất</b-button
              >
            </div>
          </template>
        </b-modal> -->
      </validation-observer>
      <!-- end of modal update unit -->

      <!-- modal delete unit -->
      <b-modal modal-class="n-b-modal" id="deleteUnit" no-close-on-backdrop>
        <!-- header -->
        <template #modal-header>
          <b class="n-b-title">Xóa đơn vị tính</b>
          <button type="button" aria-label="Close" @click="$bvModal.hide('deleteUnit')">
            <i class="el-icon-close"></i>
          </button>
        </template>
        <!-- body -->
        <template #default>
          <p>Thao tác này không thể hoàn tác</p>
        </template>

        <!-- footer -->
        <template #modal-footer>
          <div class="d-flex justify-content-end">
            <el-button class="n-btn" @click="$bvModal.hide('deleteUnit')">
            Thoát
            </el-button>
            <el-button class="n-btn" type="danger" @click="deleteSelectedUnit">
              Xóa đơn vị tính
            </el-button>
          </div>
        </template>
      </b-modal>

      <!-- <b-modal id="deleteUnit" no-close-on-backdrop>
        <template #modal-header>
          <h5 class="mb-0"><b>Xóa đơn vị tính</b></h5>
          <button
            type="button"
            aria-label="Close"
            class="close"
            @click="$bvModal.hide('deleteUnit')"
          >
            ×
          </button>
        </template>
        <template #default>
          <p>Thao tác này không thể hoàn tác</p>
        </template>
        <template #modal-footer>
          <div class="d-flex justify-content-between w-100 m-0">
            <b-button
              variant="outline-primary"
              size="md"
              class="m-0"
              @click="$bvModal.hide('deleteUnit')"
              >Thoát</b-button
            >
            <b-button
              variant="danger"
              size="md"
              class="m-0"
              @click="deleteSelectedUnit()"
              >Xóa đơn vị tính</b-button
            >
          </div>
        </template>
      </b-modal> -->
      <!-- end of modal delete unit -->

      <div class="box-loading" v-if="loading">
        <div class="loading">
          <b-spinner class="m-2" variant="primary" role="status"></b-spinner>
        </div>
      </div>
    </div>
    <NotPermission v-else></NotPermission>
  </TheLayout>
</template>

<style lang="scss">
// .modal-header,
// .modal-body,
// .modal-footer {
//   border: none;
// }

// .modal-header {
//   padding: 20px 20px;
// }

// .modal-body {
//   padding: 0 20px !important;
// }

// .modal-footer {
//   margin: 0;
//   padding: 20px;
// }
</style>
